import axios from "axios";
import { endpoints } from "./endpoints";
import qs from "qs";
import { setCookie, deleteCookie } from "../helpers/helperFunctions";

axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

// Create a new user (admin action)
async function createUser(userData) {
  // Compose the endpoint for user creation
  const url =
    endpoints.MITCO_API_URL +
    endpoints.CSFA_BASE +
    endpoints.CSFA_SITE_ADMIN +
    "create_user/";

  const response = await axios({
    method: "post",
    xsrfCookieName: "csrftoken",
    xsrfHeaderName: "X-CSRFTOKEN",
    withCredentials: true,
    url: url,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    data: userData,
  });
  return response;
}

// Login as another user (admin action)
async function loginAsUser(userId) {
  const url =
    endpoints.MITCO_API_URL +
    endpoints.CSFA_BASE +
    endpoints.CSFA_SITE_ADMIN +
    `${userId}/login_as_user/`;

  const response = await axios({
    method: "post",
    xsrfCookieName: "csrftoken",
    xsrfHeaderName: "X-CSRFTOKEN",
    withCredentials: true,
    url: url,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
  return response;
}
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

export const apiPost = {
  login: login,
  authCookie: updateAuthCookies,
  saveCartItem,
  getProductModels,
  getProductManufacturers,
  searchProductList,
  saveAdminImage,
  validateAddress,
  sendOrderByEmailFax,
  createUser,
  loginAsUser,
  collectShippingInfo,
  collectShippingInfoAsync,
  createOrder,
  validateAddress,
  sendOrderByEmailFax,
};
// example cookie: 'csrftoken=tu5QVbMTPrNhFFYsOmcUwOoC45jPrf0Kds6VqvjPkmNFGxNJqOFJlNtqGdnkojdP; expires=Fri, 11 Aug 2023 03:03:28 GMT; Max-Age=31449600; Path=/; SameSite=Lax'

function updateAuthCookies(username, expirationDays) {
  deleteCookie("username");
  setCookie("username", username, expirationDays);
}

async function login({ username, password, csrfmiddlewaretoken }) {
  const dataString = qs.stringify({
    username: username,
    password: password,
    csrfmiddlewaretoken: csrfmiddlewaretoken,
  });

  const authentication = await axios(
    endpoints.MITCO_API_URL + endpoints.USER_LOGIN,
    {
      method: "post",
      withCredentials: true,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: dataString,
    },
  );
  return authentication;
}

async function saveCartItem({ cart_key, cart_item }) {
  const data = { cart_key, cart_item };

  const url = `${endpoints.MITCO_API_URL}${endpoints.CSFA_BASE}${endpoints.CSFA_CART + cart_key + "/" + endpoints.CSFA_UPDATE_CARTITEM}`;

  const response = await axios({
    method: "post",
    xsrfCookieName: "csrftoken",
    xsrfHeaderName: "X-CSRFTOKEN",
    withCredentials: true,
    url: url,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    data: data,
  });
  return response;
}

//GET functions taht require post data
async function getProductModels(data) {
  const url = `${endpoints.MITCO_API_URL}${endpoints.CSFA_BASE}${endpoints.CSFA_PRODUCTS + endpoints.CSFA_PRODUCT_MODELS}`;

  const response = await axios({
    method: "post",
    xsrfCookieName: "csrftoken",
    xsrfHeaderName: "X-CSRFTOKEN",
    withCredentials: true,

    url: url,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    data: data,
  });
  return response;
}

async function getProductManufacturers(data) {
  const url =
    endpoints.MITCO_API_URL +
    endpoints.CSFA_BASE +
    endpoints.CSFA_PRODUCTS +
    endpoints.CSFA_PRODUCT_MANUFACTURERS;

  const response = await axios({
    method: "post",
    xsrfCookieName: "csrftoken",
    xsrfHeaderName: "X-CSRFTOKEN",
    withCredentials: true,
    url: url,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    data: data,
  });
  return response;
}

async function collectShippingInfo(data) {
  const url =
    endpoints.MITCO_API_URL +
    endpoints.CSFA_BASE +
    endpoints.CSFA_ORDERS +
    endpoints.CSFA_ORDERS_SHIPPING_INFO;

  const response = await axios({
    method: "post",
    xsrfCookieName: "csrftoken",
    xsrfHeaderName: "X-CSRFTOKEN",
    withCredentials: true,
    url: url,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    // The optimized backend normally completes in under five seconds. Keep
    // generous headroom for a cold carrier response while ensuring checkout
    // can recover from a genuinely stuck request.
    timeout: Number(process.env.REACT_APP_SHIPPING_RATE_TIMEOUT_MS || 15000),
    data: data,
  });
  return response;
}

async function collectShippingInfoAsync(data) {
  const url =
    endpoints.MITCO_API_URL +
    endpoints.CSFA_BASE +
    endpoints.CSFA_ORDERS +
    endpoints.CSFA_ORDERS_SHIPPING_INFO_ASYNC;

  return axios({
    method: "post",
    xsrfCookieName: "csrftoken",
    xsrfHeaderName: "X-CSRFTOKEN",
    withCredentials: true,
    url,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    timeout: 10000,
    data,
  });
}

async function createOrder(data) {
  const url =
    endpoints.MITCO_API_URL +
    endpoints.CSFA_BASE +
    endpoints.CSFA_ORDERS +
    endpoints.CSFA_ORDERS_CREATE;

  const response = await axios({
    method: "post",
    xsrfCookieName: "csrftoken",
    xsrfHeaderName: "X-CSRFTOKEN",
    withCredentials: true,
    url: url,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    data: data,
  });
  return response;
}

async function searchProductList({
  product_code,
  available_only,
  search_xref,
  search_description,
  search_product_code,
  search_oem_part_numbers,
  page,
  filterObject,
  productCategories,
}) {
  const url =
    endpoints.MITCO_API_URL +
    endpoints.CSFA_BASE +
    endpoints.CSFA_PRODUCTS +
    endpoints.CSFA_SEARCH_PRODUCTS;

  const response = await axios({
    method: "post",
    srfCookieName: "csrftoken",
    xsrfHeaderName: "X-CSRFTOKEN",
    withCredentials: true,
    url: url,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    params: {
      available_only,
      search_xref,
      search_description,
      search_product_code,
      search_oem_part_numbers,
      page,
      search_term: product_code,
    },
    data: { ...filterObject, productCategories },
  });
  return response;
}

async function saveAdminImage({
  end_date,
  start_date,
  label,
  image_type,
  image, // should be a blob URL or File
  filterObject,
  customer_num,
  is_parent_number,
  is_aftermarket_number,
}) {
  const url =
    endpoints.MITCO_API_URL +
    endpoints.CSFA_BASE +
    endpoints.CSFA_SITE_ADMIN +
    endpoints.CSFA_SAVE_IMAGES;

  let imageFile;

  // If `image` is a blob URL (e.g., starts with "blob:")
  if (typeof image === "string" && image.startsWith("blob:")) {
    const blobResponse = await fetch(image); // fetch from blob URL
    const blob = await blobResponse.blob();
    imageFile = new File([blob], label + ".jpeg", {
      type: blob.type,
    });
  } else {
    // If `image` is already a File (from <input type="file" />)
    imageFile = image;
  }

  const formData = new FormData();
  if (imageFile) {
    formData.append("image", imageFile);
  }
  if (label) {
    formData.append("label", label);
  }
  if (filterObject) {
    formData.append("filterObject", JSON.stringify(filterObject));
  }
  if (start_date) {
    formData.append("start_date", start_date);
  }
  if (end_date) {
    formData.append("end_date", end_date);
  }
  if (image_type) {
    formData.append("image_type", image_type);
  }
  if (customer_num != null) {
    formData.append("customer_num", customer_num);
  }
  if (is_parent_number != null) {
    formData.append("is_parent_number", is_parent_number);
  }
  if (is_aftermarket_number != null) {
    formData.append("is_aftermarket_number", is_aftermarket_number);
  }

  const response = await axios.post(url, formData, {
    withCredentials: true,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "application/json",
    },
    xsrfCookieName: "csrftoken",
    xsrfHeaderName: "X-CSRFTOKEN",
  });

  return response;
}

async function validateAddress(dropShipAddress) {
  const url = `${endpoints.MITCO_API_URL}/v1${endpoints.CSfA_VALIDATE_ADDRESS}`;

  const response = await axios({
    method: "post",
    xsrfCookieName: "csrftoken",
    xsrfHeaderName: "X-CSRFTOKEN",
    withCredentials: true,
    url: url,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    data: dropShipAddress,
  });

  return response;
}

async function sendOrderByEmailFax({ isSubOrder, faxEmailData, id }) {
  await axios({
    method: "post",
    xsrfCookieName: "csrftoken",
    xsrfHeaderName: "X-CSRFTOKEN",
    withCredentials: true,
    url: `${endpoints.MITCO_API_URL}/v1/${
      isSubOrder ? "suborder" : "quote"
    }/${id}/send_to_client/?company=mitco`,
    headers: {
      Accept: "application/json",
    },
    data: faxEmailData,
  });
}
